import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ApiService } from '@/api';
import {
    CompetitorMapping,
    CompetitorMappingsOptions,
    PaginatedResponse
} from '@/interfaces';

@Injectable({
    providedIn: 'root'
})
export class CompetitorMappingsService {
    constructor(private apiService: ApiService) {}

    listing(params: Record<string, any>): Observable<PaginatedResponse<CompetitorMapping>> {
        return this.apiService.get<any>('/competitor-mappings', this.apiService.build(params)).pipe(
            map((res: any) => ({
                data: res.data,
                total: res.total,
                current_page: res.current_page,
                per_page: res.per_page
            }))
        );
    }

    view(id: string): Observable<any> {
        return this.apiService.get<CompetitorMapping>(`/competitor-mappings/${id}`);
    }

    edit(id: string, data: Record<string, any>): Observable<CompetitorMapping> {
        return this.apiService.patch<CompetitorMapping>(`/competitor-mappings/${id}`, data).pipe(map((response) => response.data));
    }

    export(params: Record<string, any>): Observable<Blob> {
        return this.apiService.postBlob('/competitor-mappings/export', params);
    }

    options(context: Record<string, any> = {}): Observable<CompetitorMappingsOptions> {
        return this.apiService.get<CompetitorMappingsOptions>(
            '/competitor-mappings/options',
            this.apiService.build(context)
        ).pipe(map((res) => res.data ?? res));
    }

    autocomplete(field: 'agency_name' | 'competitor_mapped', query: string, context: Record<string, any> = {}) {
        return this.apiService.get<string[]>(
            `/competitor-mappings/autocomplete/${field}`,
            this.apiService.build({ q: query, ...context })
        );
    }
}
